<template>
  <div class="floating-contact-wrap">
    <div class="floating-contact-btn shadow">
      <i class="floating-contact-icon btn-unactive icon-envelope21"></i>
      <i class="floating-contact-icon btn-active icon-line-plus"></i>
    </div>
    <div class="floating-contact-box">
      <div id="q-contact" class="widget quick-contact-widget clearfix">
        <div class="floating-contact-heading bgcolor p-4 rounded-top">
          <h3 class="mb-0 font-secondary h2 ls0">Sorularını Cevaplayalım 👋</h3>
          <p class="mb-0">Bizimle İletişime Geç</p>
        </div>
        <div class="form-widget" data-alert-type="false">
          <loading :active.sync="busy" :is-full-page="false"></loading>
          <form
            class="mb-0"
            id="floating-contact"
            action="#"
            method="post"
            enctype="multipart/form-data"
          >
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text nobg">
                  <i class="icon-user-alt"></i>
                </span>
              </div>
              <input
                type="text"
                name="name"
                id="floating-contact-name"
                class="form-control required"
                value
                placeholder="İsminiz"
                required
              />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text nobg">
                  <i class="icon-at"></i>
                </span>
              </div>
              <input
                type="email"
                name="email"
                id="floating-contact-email"
                class="form-control required"
                value
                placeholder="Emaıl Adresiniz"
                required
              />
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text nobg">
                  <i class="icon-comment21"></i>
                </span>
              </div>
              <textarea
                id="floating-contact-message"
                class="form-control required"
                cols="30"
                rows="4"
                name="message"
                required
              ></textarea>
            </div>
            <input
              type="hidden"
              id="floating-contact-botcheck"
              name="floating-contact-botcheck"
              value
            />
            <button
              type="submit"
              name="floating-contact-submit"
              class="btn btn-dark btn-block py-2"
              @click="sendMessage()"
              :disabled="busy"
            >
              Mesaj Gönder
            </button>
            <input type="hidden" name="prefix" value="floating-contact-" />
            <input
              type="hidden"
              name="subject"
              value="Messgae From Floating Contact"
            />
            <input
              type="hidden"
              name="html_title"
              value="Floating Contact Message"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      busy: false
    };
  },
  mounted() {
    var elementParent = jQuery(".floating-contact-wrap");
    jQuery(".floating-contact-btn")
      .off("click")
      .on("click", function() {
        elementParent.toggleClass("active");
      });
  },
  methods: {
    sendMessage() {
      let self = this;
      let data = jQuery("#floating-contact").serialize();
      self.busy = true;
      jQuery.ajax({
        type: "GET",
        url:
          "https://us-central1-bgplatformu-9d0d3.cloudfunctions.net/sendMails",
        data: data,
        error: function(err) {
          self.busy = false;
          alert(`Hata: ${err}\nLütfen daha sonra tekrar deneyiniz.`);
          self.name = "";
          self.email = "";
          self.message = "";
        },
        success: function() {
          self.busy = false;
          alert(
            "Teşekkürler! Mesajınız alınmıştır.\nEn kısa sürede sizinle iletişime geçeceğiz."
          );
          self.name = "";
          self.email = "";
          self.message = "";
        }
      });
    }
  }
};
</script>

<style lang="scss">
textarea.form-control {
  color: #000 !important;
}
@media (max-width: 991px) {
  .floating-contact-wrap {
    right: 25px;
    .floating-contact-btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .floating-contact-box {
      right: 0;
    }
  }
}
</style>
